export const ROLS = {
	admin: [
		'home-main',
		'followup-main',
		'followup-reports-admin',
		'followup-request-admin',
		'followup-purchase-orders-admin',
		'followup-claims-admin',
		'followup-quotation-admin',
		'recipe-history-main',
		'recipe-history-qf-admin',
		'products-main',
		'products-migration-admin',
		'products-stock-admin',
		'pharmacy-main',
		'pharmacy-letters-admin',
		'pharmacy-locals-admin',
		'configuration-main',
		'configuration-slider-admin',
		'configuration-icons-admin',
		'configuration-users',
		'configuration-users-add-rol',
		'configuration-users-local',
		'configuration-users-email',
		'configuration-users-search',
		'payments-main',
		'payments-token',
		'payments-pos',
		'configuration-landing-admin',
		'configuration-carousel-admin',
		'configuration-users-management-admin',
	],
	pharmacy: [
		'followup-main',
		'followup-request',
		'followup-claims',
		'followup-purchase-orders',
		'followup-notifications',
		'followup-reports',
		'followup-quotation',
		'followup-preorder',
		'products-main',
		'products-migration',
		'products-stock',
		'pharmacy-main',
		'pharmacy-letters',
		'pharmacy-locals',
		'recipe-history-main',
		'recipe-history-qf',
		'configuration-slider',
		'configuration-main',
		'configuration-landing',
		'configuration-icons',
		'configuration-carousel',
		'configuration-users-management',
	],
};
